import {
  Alert,
  Modal,
  ModalContent,
  ModalFooter,
  useToaster
} from "@dealer-center/core-components";
import { SaveAndCancel } from "@dealer-center/core-custom-components";
import { useDealerCodeMappingDelete } from "@dealer-center/ddc-pages-dealer-codes-fetch";
import type { dealerCodeMappingDeleteModalInterface } from "./helper";
interface DealerCodesDeleteModalProps {
  values: dealerCodeMappingDeleteModalInterface;
  show: boolean;
  close: () => void;
}

export const DealerCodesDeleteModal = ({
  close,
  values,
  show
}: DealerCodesDeleteModalProps) => {
  const { account, dealerCodeType, id } = values;
  const { toastError, toastSuccess } = useToaster();
  const { mutate, isError, isSuccess, isPending } =
    useDealerCodeMappingDelete();
  if (isError) {
    toastError("Error deleting dealer code mapping");
    close();
  }
  if (isSuccess) {
    toastSuccess(
      "Success",
      `Dealer code mapping ${dealerCodeType} deleted successfully`
    );
    close();
  }

  return (
    <Modal
      className="sample-modal-dialog"
      footer={{
        primary: {
          label: "unused"
        },
        footerComponent: (
          <ModalFooter>
            <SaveAndCancel
              analyticsEventName="Dealer Code Delete"
              isSaving={isPending}
              saveButtonText="Delete"
              onCancel={close}
              onSave={() => {
                mutate(id || "");
              }}
            />
          </ModalFooter>
        )
      }}
      header={`Delete Dealer ${dealerCodeType} Code from ${
        account.displayName || account.id
      }`}
      show={show}
      size="small"
      onHide={close}
    >
      <ModalContent>
        <Alert role="alert" sx={{ marginBottom: "16px" }} type="error">
          Are you sure
        </Alert>
      </ModalContent>
    </Modal>
  );
};
